export default __webpack_public_path__ + "static/media/april.869abe6f.jpg";